import React, { useContext, useEffect, useState } from "react";

import Icon from "../../Assets/Images/Souvenir/Icons/auction.png";
// import ApplyImg from "../../Assets/Images/Souvenir/Illustration/Gift.svg";

// import "./AuctionDetails.css";
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import RightSideAuctionWithoutTime from "../../components/StarShowcase/Auction/Content/RightSideAuction/RightSideAuctionWithoutTime";
import Navigation from "../../components/Layouts/Header/Navigation";
import { serverInfo } from "../../App";

function AcquiringProduct() {

  const { imageCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const params = useParams();
  const [auctionInfo, setAuctionInfo] = useState([]);
  const [sideData, setSideData] = useState([]);
  // const [userInfo , setUserInfo] = useState([]);
  const [showMore, setShowMore] = useState(false);

  const dateTime = new Date();
  const endTime = new Date(auctionInfo?.auction?.result_date);

  const showResult = () => {
    history.push(`/auction-winner/${auctionInfo?.auction?.id}`);
  };

  useEffect(() => {
    axios.get(`/api/user/auctionApply/auction/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setAuctionInfo(res.data.auctionApply);
        // setUserInfo(res.data.userInfo);
      }
    });
    axios.get(`/api/user/getStarAuctionProduct/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setSideData(res.data.product);
        // setUserInfo(res.data.userInfo);
      }
    });
  }, []);

  return (
    <>
      <Navigation />

      <div className="container mt-3">
        <img
          src={imageCdnUrl + auctionInfo?.auction?.banner}
          className="img-fluid w-100 CR7Cover"
          alt=""
          style={{ height: "500px" }}
        />

        <div className="row justify-content-between">
          <div className="col-md-7">
            <h3 className="fw-bolder text-white mt-4">
              {auctionInfo?.auction?.title}
            </h3>

            <p className="text-white PText">
              {showMore ? (
                <Markup content={auctionInfo?.auction?.details} />
              ) : (
                <Markup
                  content={auctionInfo?.auction?.details.substring(0, 50)}
                />
              )}
              <button
                className="btn text-white PText"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? "Show less" : "Show more"}
              </button>
            </p>

            <div className="notify-img bg-dark text-center">
              <img
                // src={ApplyImg}
                alt="this is Apply msg"
                className="img-fluid ApplyImg p-5"
              />
              <div className="content-info  py-1">
                <h4 className="text-light text-center">
                  Result will be published on
                </h4>
                <h3 className="text-light text-center">
                  {moment(auctionInfo?.auction?.result_date).format("LL")}{" "}
                </h3>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <button
                disabled={
                  dateTime?.getTime() < endTime?.getTime() ? true : false
                }
                className="btn btn-warning fw-bold px-5 py-2 my-2"
                onClick={showResult}
              >
                <img src={Icon} alt="" className="mx-2 " height={18} /> Result
              </button>
            </div>
          </div>

          <div className="col-md-4 ">
            {sideData &&
              sideData?.map((product) => (
                <RightSideAuctionWithoutTime data={product} />
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default AcquiringProduct;
